import Vue from 'vue'
import VueRouter from 'vue-router'

// 读取配置文件中的网站标题
let strSiteName = require('@/config/global').title



const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
const Home = () => import('views/home/Home')
const Denied = () => import('views/Denied')
const Login = () => import('views/login/Login')
const Profile = () => import('views/profile/Profile')
const MemberList = () => import('views/member/List')
const MemberDetail = () => import('views/member/Detail')
const ServiceList = () => import('views/service/List')
const ServiceDetail = () => import('views/service/Detail')
const OrderList = () => import('views/order/List')
const OrderDetail = () => import('views/order/Detail')

const routes = [
	{
		path: '',
		redirect:  '/login'
	},
	{
		path: '/login',
		component: Login,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/denied',
		component: Denied,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/home',
		component: Home,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/profile',
		component: Profile,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/member-list',
		component: MemberList,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/member-detail',
		component: MemberDetail,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/service-list',
		component: ServiceList,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/service-detail',
		component: ServiceDetail,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/order-list',
		component: OrderList,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/order-detail',
		component: OrderDetail,
		meta: {
			title: strSiteName
		}
	},
]

const router = new VueRouter({
	scrollBehavior: () => ({ y: 0}),
	routes,
	mode: 'history'
})

router.beforeEach((to, from , next) =>{
	window.document.title = to.meta.title

	// const TOKEN = localStorage.getItem('token')
	// if(!TOKEN){
	// 	if(to.path === '/authorization'){
	// 		next()
	// 	}else{
	// 		localStorage.setItem('go-url', to.fullPath)
	// 		next('/authorization')
	// 	}
	// }else{
	// 	next()
	// }
	next()
})

export default router
